export default (pathname: string) => {
  let normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;
  normalizedPathname =
    pathname.endsWith('/') || pathname.startsWith('search/')
      ? normalizedPathname
      : `${normalizedPathname}/`;
  return normalizedPathname;
};
